class VipTiers {
	constructor(vipTiers, currentStatusLabel, benefitHeaders, benefitHeadersTitle, benefitsList, customer) {
		this.vipTiers = vipTiers;
		this.currentStatusLabel = currentStatusLabel;
		this.benefitHeaders = benefitHeaders;
		this.benefitHeadersTitle = benefitHeadersTitle;
		this.benefitsList = benefitsList;
		this.customer = customer;
	}


	renderVipTiers() {
		
		// $(".loyalty-vip-tiers-container").append(
		// 	$("<div>").addClass("loyalty-slick-nav-container"),
		// 	$("<div>").addClass("loyalty-benefit-headers").append(
			
		// 		$("<div>").addClass("loyalty-benefit-headers-list-item").addClass("loyalty-benefit-list-header").text(this.benefitHeadersTitle)
		// 		),
		// 		$("<div>").addClass("loyalty-benefit-list")
		// 	);
			//headers column
			// this.benefitHeaders.forEach(header => {
			// 	$(".loyalty-benefit-headers").append(
			// 		$("<div>").addClass("loyalty-benefit-headers-list-item").text(header)
			// 		)
			// });

			// creates the 4 columns - one for each tier
			// this.benefitsList.forEach(benefit => {
			// 	$(".loyalty-benefit-list").append(
			// 		$("<div>", {
			// 			class: `loyalty-vip-tier-item-${benefit.tierId}`
			// 		}).addClass("loyalty-vip-tier").append(
			// 		$("<div>").addClass("loyalty-vip-tier-header-container").append(
			// 			$("<div>").addClass("loyalty-vip-tier-status-container").append(
			// 			$("<div>").addClass("loyalty-vip-tier-current-status-container"),
			// 			$("<div>").addClass("loyalty-vip-tier-next-requirement-container")

			// 			),
			// 			$("<div>").addClass("loyalty-vip-tier-benefit-item").addClass("loyalty-vip-tier-name").text(this.getVipTierName(benefit.tierId)),
			// 			$("<div>").addClass("loyalty-vip-tier-requirement").text(benefit.tierRequirement)
			// 		)
			// 		)
			// 		);
			// 	benefit.benefits.forEach(item => {
			// 		$(`.loyalty-vip-tier-item-${benefit.tierId}`).append(
			// 			$("<div>").addClass("loyalty-vip-tier-benefit-item").text(item)
			// 			)

			// 	})

			// })

   
			// this.replaceCheck();
			// this.makeSlick();
      
      if (this.customer.created_at !== undefined && this.customer.vipTier !== null) {
 			this.renderCurrentStatus();
    } else {
    }
		
			
	}

	replaceCheck() {
		$( "div.loyalty-vip-tier-benefit-item:contains('●')" ).text("").addClass("fa fa-check");
		
		}
	getVipTierName(id) {
		return this.vipTiers[this.vipTiers.map(tier => tier.id).indexOf(id)].name
	}



	renderCurrentStatus() {
		if (this.customer.created_at !== undefined && this.customer.vipTier.id === 12894) {
            $(".loyalty-vip-current-tier-container.loyalty-vip-current-tier-silver").css('display', "flex");
            $("#loyalty-tier-current").addClass("loyalty-silver");
            // $(".loyalty-tiers-table-container").css('display', 'none')

        } else {}

        if (this.customer.created_at !== undefined && this.customer.vipTier.id === 12895) {
            $(".loyalty-vip-current-tier-container.loyalty-vip-current-tier-gold").css('display', "flex")
            $("#loyalty-tier-current").addClass("loyalty-gold");
            // $(".loyalty-tiers-table-container").css('display', 'none');
		} else {}

        if (this.customer.created_at !== undefined && this.customer.vipTier.id === 12896) {
            $(".loyalty-vip-current-tier-container.loyalty-vip-current-tier-black").css('display', "flex")
            $("#loyalty-tier-current").addClass("loyalty-black");
            // $(".loyalty-tiers-table-container").css('display', 'none');
		} else {}

        
	}



	

	// makeSlick() {
	// 	if (Array.from(document.querySelectorAll("script")).filter(script => script.src.includes("slick")).length < 1) {
	// 		var newscript = document.createElement('script');
	// 		     newscript.type = 'text/javascript';
	// 		     newscript.async = true;
	// 		     newscript.src = 'https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js';
	// 		  (document.getElementsByTagName('head')[0]||document.getElementsByTagName('body')[0]).appendChild(newscript);
	// 	};
		
		  
	// 	  setTimeout(function(){
	// 	    $('.loyalty-benefit-list').slick({
	// 	        slidesToShow: 3,
	// 	        slidesToScroll: 1,
	// 	        arrows: false,
	// 	        adaptiveHeight: true,
		        
	// 	        responsive: [
	// 	          {
	// 	          	breakpoint: 769, settings: {slidesToShow: 1, slidesToScroll: 1, dots: true, appendDots: $('.loyalty-slick-nav-container')}
	// 	          }
	// 	       ]});
	// 	    }, 2000);
	// }
}



